import { createFileRoute } from '@tanstack/react-router';
import { emailRecipientsQueryOptions } from '@utils/queryOptions';
import EmailRecipients from '@Views/Emails/sent/details/recipients';

export const Route = createFileRoute('/emails/(sent)/$emailId/')({
    component: EmailRecipients,
    loader: opts =>
        opts.context.queryClient.ensureQueryData(
            emailRecipientsQueryOptions(opts.params.emailId),
        ),
});
